import {
  Button,
  HStack,
  Stack,
  StackSeparator,
  Text,
} from "@chakra-ui/react";
import { TreatmentType } from "@keita/lanepatrol-sdk";
import { t } from "i18next";
import { StmAttributeChange } from "./components/StmAttributeChange";
import { CustomDialog } from "../CustomDialog";

const allTreatmentTypes = Object.values(TreatmentType);

interface Props {
  autoFocusTreatmentType?: TreatmentType;
  onClose: () => void;
}
export const StmModal: React.FC<Props> = ({
  onClose,
  autoFocusTreatmentType,
}) => {
  return (
    <CustomDialog
      size="xl"
      onClose={onClose}
      header={t("map:treatments.stm")}
      footer={
        <Button colorPalette="primary" variant="ghost" onClick={onClose}>
          {t(`shared:close`)}
        </Button>
      }
    >
      <Stack gap={8} separator={<StackSeparator />}>
        {allTreatmentTypes.map((treatment) => (
          <HStack key={treatment} gap={4} separator={<StackSeparator />}>
            <Stack position="relative">
              {treatment === autoFocusTreatmentType && (
                <Button
                  position="absolute"
                  top="50%"
                  left="50%"
                  boxSize={0}
                  autoFocus
                />
              )}
              <Text fontSize="md" fontWeight="semibold">
                {t(`sdk:treatments.${treatment}`)}
              </Text>
              <Text fontSize="sm" textAlign="justify">
                {t(`sdk:treatments.description.${treatment}`)}
              </Text>
              <Text fontSize="sm" textAlign="justify">
                {t("map:treatments.modelOutcome")}
              </Text>
              <HStack>
                <StmAttributeChange treatmentType={treatment} />
              </HStack>
            </Stack>
          </HStack>
        ))}
      </Stack>
    </CustomDialog>
  );
};
